import { ReactNode, useEffect, useState } from 'react';
import parse from 'html-react-parser';

import bemClassName from '../../utils/bem';

import './index.scss';
import Public from '../../API/Public';
import Loading from '../../UI/Loading';

const servicesRules = bemClassName('services-rules');

const ServicesRules = () => {
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  let parsedHTML;
  if (data) {
    parsedHTML = parse(data.content);
  }

  useEffect(() => {
    document.title = 'Правила сервиса';
    setIsLoading(true);
    Public.getServiceRules()
      .then((items) => {
        setData(items);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, []);

  return (
    <>
      {isLoading ? (
        <Loading externalClassName={servicesRules('loading')} />
      ) : (
        data && (
          <>
            <h2 className={servicesRules('title')}>{data.title}</h2>
            <div className={servicesRules('inner')}>{parsedHTML as ReactNode}</div>
          </>
        )
      )}
    </>
  );
};

export default ServicesRules;
